import Keycloak from 'keycloak-js';

const {
  REACT_APP_KEYCLOAK_URL,
  REACT_APP_KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_CLIENT_ID,
} = process.env;

if (!REACT_APP_KEYCLOAK_URL || !REACT_APP_KEYCLOAK_REALM || !REACT_APP_KEYCLOAK_CLIENT_ID) {
  throw new Error('Missing Keycloak env vars. Check .env');
}

const keycloakClient = new Keycloak({
  url: REACT_APP_KEYCLOAK_URL,
  realm: REACT_APP_KEYCLOAK_REALM,
  clientId: REACT_APP_KEYCLOAK_CLIENT_ID,
});


export default keycloakClient;
